<template>
  <!-- <component
    :is="tag"
    v-on="$listeners"
  >
    <div class="operator-group">
      <b-avatar
        class="merchant-profile"
        size="42"
        :variant="isActive ? 'light-light' : 'light-primary'"
        :src="service.merchantUserProfile"
        :text="avatarText(service.merchantUserName)"
      >
        <feather-icon
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
      <b-avatar
        size="42"
        :badge="false"
        class="badge-minimal customer-profile"
        :badge-variant="service.isOnline ? 'success' : 'secondary'"
        :variant="isActive ? 'light-light' : 'light-primary'"
      >
        <feather-icon
          icon="CastIcon"
          size="22"
        />
      </b-avatar>
    </div>
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0 text-truncate">
        {{ service.shortenName }}
      </h5>
      <div class="status-container">
        <div style="font-size: 10px">
          <b-badge
            v-if="service.status === 'pending'"
            pill
            size="10px"
            variant="warning"
            badge-glow
          >
            {{ $t(`status.pending`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'processing'"
            pill
            size="10px"
            badge-glow
            :style="{
              background: '#007bff',
              color: '#fff'
            }"
          >
            {{ $t(`status.processing`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'cancel'"
            pill
            size="10px"
            variant="danger"
            badge-glow
          >
            {{ $t(`status.cancel`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'hold'"
            pill
            size="10px"
            variant="primary"
            badge-glow
          >
            {{ $t(`status.hold`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'completed'"
            pill
            size="10px"
            variant="success"
            badge-glow
          >
            {{ $t(`status.completed`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'resolved'"
            pill
            variant="secondary"
            badge-glow
          >
            {{ $t(`status.closed`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'unresolved'"
            pill
            variant="danger"
            badge-glow
          >
            {{ $t(`status.unresolved`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'accepted'"
            pill
            variant="success"
            badge-glow
          >
            {{ $t(`status.accepted`) }}
          </b-badge>
          <b-badge
            v-else-if="service.status === 'pendingPrice'"
            pill
            variant="primary"
            badge-glow
          >
            {{ $t(`status.pendingPrice`) }}
          </b-badge>
          <b-badge
            v-else
            pill
            size="10px"
            variant="secondary"
            badge-glow
          >
            {{ $t(`status.unknown`) }}
          </b-badge>
        </div>
        <p class="date">
          {{ service.createdAt | formatShortDate }}
        </p>
      </div>
    </div>
    <div
      class="chat-meta text-nowrap"
      style="margin-bottom: auto; margin-top: 8px; display: block;"
    >
      <small
        v-if="service.latestMessage"
        class="d-block mb-25 chat-time"
      >
        {{ service.latestMessage.createdAt | formatShortDate }}
      </small>
      <div class="d-flex align-items-center justify-content-end">
        <div
          v-if="service.priority && service.status != 'resolved' && service.status != 'cancel'"
          v-b-tooltip.hover.top
          :title="$t('chat.highPriority')"
          class="priority-indicator"
          :style="{
            backgroundColor: isActive ? 'rgba(255, 255, 255, 0.12)' : 'rgba(234, 84, 85, 0.12)',
            '--border-color': isActive ? '#ffffff' : '#ea5455',
            '--icon-color': isActive ? '#ffffff' : '#ea5455'
          }"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="14"
            class="pulsing-icon"
          />
        </div>
        <b-badge
          v-if="service.badgeCount && service.assignedOperatorId === userData.id"
          pill
          variant="primary"
          class="float-right c-badge ml-1"
        >.</b-badge>
      </div>
    </div>
  </component> -->
  <div />
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
import messageType from '@/data/messageType'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    service: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageType,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  methods: {
    avatarText(name) {
      if (!name) return ''
      return name.charAt(0).toUpperCase()
    },
  },
}
</script>

<style lang="scss" scoped>
  .status-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .date {
    font-size: 12px;
    justify-self: end;
    margin-bottom: 0;
    color: #b9b9c3;
  }

  .c-badge {
    height: 11px;
    width: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 50%;
    color: var(--primary);
    padding: 0;
  }

  .priority-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 2px solid var(--border-color);
      animation: pulse 2s ease-out infinite;
      opacity: 0;
    }

    svg {
      color: var(--icon-color);
      stroke-width: 2.5px;
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(0.95);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.2);
      opacity: 0;
    }
    100% {
      transform: scale(0.95);
      opacity: 0;
    }
  }

  .pulsing-icon {
    animation: glow 2s ease-in-out infinite;
  }

  @keyframes glow {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
</style>
